<template>
  <div>
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h2 class="font-24 font-r">
      Podróżuj tak jak lubisz z TravelOne.pl&nbsp;&reg;
    </h2>
    <a-row>
      <a-col>
        <div class="content-pane content-pane_white mb-48">
          <div class="map-section">
            <T1Map :grupy="grupy" />
          </div>
          <div class="directions-section">
            <div class="section-top-bar">
              <div class="section-top-bar__title">
                <span class="d-inline-block d-sm-none mr-4"
                  >Ilość regionów:</span
                >
                <span
                  class="d-none d-sm-inline-block mr-4"
                  v-html="getGroupName()"
                ></span>
                <span class="font-r">
                  <span class="d-none d-sm-inline">(</span
                  >{{ getGroupQuantity()
                  }}<span class="d-none d-sm-inline">)</span>
                </span>
              </div>
              <div class="section-top-bar__tools" @click="sortItems">
                <span class="mt-2 pr-4"
                  >Sortuj <span class="d-none d-xs-inline">wg nazwy</span></span
                >
                <template v-if="sortingAsc">
                  <a-icon type="sort-descending" class="font-18" />
                </template>
                <template v-else>
                  <a-icon type="sort-ascending" class="font-18" />
                </template>
              </div>
            </div>
            <div class="mb-md-16">
              <T1DirectionGroupItem
                :portale="filteredItems"
                :loading="loading"
              />
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { portaleTurystyczne } from "./portaleTurystyczneMapa.js";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1DirectionGroupItem from "./T1PortaleTurystyczne/T1DirectionGroupItem";
import T1Map from "./T1PortaleTurystyczne/T1Map";

export default {
  data: () => ({
    grupy: portaleTurystyczne.page.response.grupypanstw,
    portale: portaleTurystyczne.page.response.innepanstwa,
    portaleFiltered: [],
    sortingAsc: false,
    loading: true,
    groupIdx: "0"
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({
        name: "Portale turystyczne",
        link: ""
      });
      return crumbsArr;
    },
    sortItems() {
      this.sortingAsc = !this.sortingAsc;
      let sortedArr = this.portale;
      if (this.sortingAsc) {
        sortedArr.sort((a, b) =>
          a.maindata.name.localeCompare(b.maindata.name)
        );
      } else {
        sortedArr.reverse();
      }
      this.portaleFiltered = sortedArr;
      this.loadingToggle();
    },
    groupItems() {
      let that = this;
      let sortedArr = [];
      sortedArr = this.portale.filter(function(obj) {
        return obj.maindata.grupa === that.groupIdx;
      });
      this.portaleFiltered = sortedArr;
      this.loadingToggle();
      return this.portaleFiltered;
    },
    loadingToggle() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    getGroupName() {
      let that = this;
      if (this.groupIdx != "0") {
        let activeGroup = this.grupy.filter(function(obj) {
          return obj.id == that.groupIdx;
        });
        return activeGroup[0].name;
      } else {
        return "Wszystkie";
      }
    },
    getGroupQuantity() {
      if (this.groupIdx == "0") {
        return this.portale.length;
      } else {
        return this.portaleFiltered.length;
      }
    }
  },
  computed: {
    filteredItems() {
      let that = this;
      this.$root.$on("update:groupIdx", val1 => {
        that.groupIdx = val1;
      });
      if (this.groupIdx == "0") {
        this.loadingToggle();
        return this.portale;
      } else {
        this.groupItems();
      }
      return this.portaleFiltered;
    }
  },
  components: {
    T1Breadcrumbs,
    T1DirectionGroupItem,
    T1Map
  }
};
</script>

<style lang="scss" scoped>
.section-top-bar {
  border-bottom: 1px solid $gray-10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 12px 0;

  &__title {
    @include text-truncate();
    @include font-m();
    display: flex;
    font-size: 18px;

    @media (min-width: $screen-sm) {
      font-size: 20px;
    }
  }

  &__tools {
    @include text-truncate();
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0px 6px;
    user-select: none;
    transition: all ease-in-out 0.2s;

    &:hover {
      background-color: rgba($gray-10, 0.5);
    }
  }
}
</style>
